export default function (customClasses, targetClassName) {
  if (customClasses[targetClassName]) {
    return [customClasses[targetClassName]];
  } else return [targetClassName];
}
